const angular = require('angular');
const uiRouter = require('angular-ui-router');
import routing from './help.routes';

export class MainController {

	getDFFields: any;
	loading: boolean;
	DSFields: Array<any> = [];
	$scope: any;
	searchText: string = '';
	DSType = {
		Single: 'single',
		Multiple: 'multiple'
	};

	/*@ngInject*/
	constructor(Util, $scope) {
		let self = this;
		this.$scope = $scope;
		this.loading = true;
		this.getDFFields = Util.getFixedFieldsFromServer();
		this.getDFFields.then(function (response) {
			self.setData(response);
		}, function () {
			self.loading = false;
			self.$scope.$digest();
		})
	}

	setData(response) {
		let self = this;
		if (response && response.data && response.data.entity) {
			this.DSFields = this.DSFields.concat(response.data.entity.multiValueFixedFields.map(function (val, index) {
				val.type = self.DSType.Multiple;
				return val;
			}));
			this.DSFields = this.DSFields.concat(response.data.entity.singleValueFixedFields.map(function (val, index) {
				val.type = self.DSType.Single;
				return val;
			}));
			this.DSFields = this.DSFields.map(function(val, index){
				val.id = index;
				delete val.name;
				return val;
			});
		}
		self.loading = false;
		self.$scope.$digest();
	}

};

export default angular.module('nodeApp.help', [
	uiRouter])
	.config(routing)
	.component('help', {
		template: require('./help.html'),
		controller: MainController
	})
	.name;



// WEBPACK FOOTER //
// ./client/app/help/help.component.ts